<template>
  <div ref="inspectVideo" class="w-full h-full"></div>
</template>

<script>
export default {
  name: 'inspectVideo',
  props: {
    cameraInfo: { // 摄像头信息
      type: Object,
      default: () => {
        return {}
      }
    },
    videoInfo: { // 账号密码信息
      type: Object,
      default: () => {
        return {}
      }
    },
    accessToken: String
  },
  data() {
    return {
      iframeObj: {},
      loop: true,
    }
  },
  mounted() {
    const cameraInfo = JSON.parse(JSON.stringify(this.cameraInfo))
    this.creatWindow(cameraInfo)
  },
  watch: {
    cameraInfo(newVal) {
      console.log('cameraInfo', newVal)
      const cameraInfo = JSON.parse(JSON.stringify(newVal))
      if (this.iframeObj?.id) {
        this.playLive(cameraInfo)
      } else {
        this.creatWindow(cameraInfo)
      }
    }
  },
  methods: {
    creatWindow(cameraInfo) {
      const iframeObj = imosSdk.createPanelWindow()
      this.iframeObj = iframeObj
      // 如果窗格创建已经到达上限
      if (iframeObj === null) {
        throw new Error('窗格上限')
      }
      const videoDom = this.$refs.inspectVideo
      videoDom.innerHTML = null

      let divDom = document.createElement('div')
      divDom.style = 'width:100%;height:100%;'
      divDom.appendChild(this.iframeObj)
      videoDom.appendChild(divDom)
      divDom = null
      this.playLive(cameraInfo)
    },
    // async playLive1(cameraInfo) {
    //   await this.sleep(1000)
    //   if (cameraInfo.presetList && cameraInfo.cameraCode === this.cameraInfo.cameraCode) {
    //     // 轮询预置点
    //     this.playPreset(cameraInfo)
    //   }
    // },
    // 实时播放
    playLive(cameraInfo) {
      imosSdk.playLive(
        this.iframeObj.id, // 播放窗格的Id
        cameraInfo.cameraCode, // 摄像头编码
        cameraInfo.cameraCode, // 需要显示的标题名称
        async (e) => {
          await this.sleep(3000)
          if (e.ErrCode === 0 && cameraInfo.presetList && cameraInfo.cameraCode === this.cameraInfo.cameraCode) {
            // 轮询预置点
            this.playPreset(cameraInfo)
          } else {
            throw e
          }
        },
        2, // 码流类型; 1 = 主码流；2 = 辅码流
      )
    },
    /* eslint-disable no-await-in-loop */
    // 轮播预置点位
    async playPreset(video) {
      let isRetrun = false
      for (let i = 0; i < video.presetList.length; i += 1) {
        const presetItem = video.presetList[i]
        if (video.cameraCode !== this.cameraInfo.cameraCode || !this.loop) {
          if (video?.initPresetInfo?.PresetValue) {
            await this.returnInitPreset(video)
          }
          isRetrun = true
          break
        }
        await this.usePreset(video, presetItem)
        console.log('usePreset', video.cameraCode)
        await this.sleep(3000)
      }

      if (video.cameraCode === this.cameraInfo.cameraCode && this.loop) {
        this.playPreset(video)
      } else if (video?.initPresetInfo?.PresetValue && !isRetrun) {
        this.returnInitPreset(video)
      }
    },
    sleep(time) {
      return new Promise((resolve) => {
        setTimeout(() => {
          resolve()
        }, time)
      })
    },
    // 回到初始位置 删除初始预置位
    async returnInitPreset(video) {
      console.log('returnInitPreset')
      await this.usePreset(video, video.initPresetInfo)
      await this.delPreset(video, video.initPresetInfo)
    },
    // async returnInitPreset1() {
    //   console.log('returnInitPreset')
    //   await this.sleep(1000)
    // },
    // usePreset1() {
    //   return new Promise((resolve) => {
    //     setTimeout(() => {
    //       resolve()
    //     }, 2000)
    //   })
    // },
    // 使用预置位
    usePreset(video, preset) {
      return new Promise((resolve) => {
        const url = `http://${this.videoInfo.ipAddress}:${this.videoInfo.port}/VIID/ptz/preset/use/${video.cameraCode}/${preset.PresetValue}`
        const requestOption = {
          method: 'GET',
          headers: {
            'Content-Type': 'application/json; charset=utf8',
            Authorization: this.accessToken,
          },
        }
        fetch(url, requestOption)
          .then((response) => {
            if (response.status === 200) {
              return response.json()
            }
            throw new Error('网络请求失败')
          })
          .then((res) => {
            if (res.ErrCode === 0) {
              resolve()
            } else {
              resolve()
              throw new Error(res.ErrMsg)
            }
          })
          .catch((error) => {
            resolve()
            throw new Error(error)
          })
      })
    },
    // 删除初始预置点位
    delPreset(video, preset) {
      const url = `http://${this.videoInfo.ipAddress}:${this.videoInfo.port}/VIID/ptz/preset/${video.cameraCode}/${preset.PresetValue}`
      const requestOption = {
        method: 'DELETE',
        headers: {
          'Content-Type': 'application/json; charset=utf8',
          Authorization: this.accessToken,
        },
      }
      fetch(url, requestOption)
        .then((response) => {
          if (response.status === 200) {
            return response.json()
          }
          throw new Error('网络请求失败')
        })
        .then((res) => {
          if (res.ErrCode) {
            throw new Error(res.ErrMsg)
          }
        })
        .catch((error) => {
          throw new Error(error)
        })
    }
  },
  beforeDestroy() {
    this.loop = false
  },
}
</script>

<style lang="scss">
.imosSdk-video {
  width: 100% !important;
  height: 100% !important;
  border-width: 0 !important;
}
</style>
